<!--
  Program: main page
  Author: SDL
  Brief: main layout template
-->
<template>
  <div
    id="mainWrapperDiv"
    class="wrapper"
    :class="{
      'ui---lnb-collapsed': isFoldSideMenu,
      'aside-hide': isHideSideMenu,
      's-main': isHideSideMenu,
      'ui---lnb': !isHideSideMenu,
    }"
  >
    <!--aside-hide aside-collapsed-->
    <!-- GNB -->
    <top-menu @router-reload="routerReload()" :fixTop="fixTop" @toggleFixTop="toggleFixTop"></top-menu>
    <!-- SUB Layout -->
    <section class="section_container" @click="toggleFixTop(false)">
      <!-- LEFT Navigtion -->
      <side-menu
        v-if="!isHideSideMenu"
        @router-reload="routerReload()"
        @fold-event="isFoldSideMenu = !isFoldSideMenu"
        @hide-event="displaySideMenu"
      />
      <!-- SUB Contents -->
      <router-view v-if="isRouterAlive" :key="$route.fullPath"></router-view>
      <!-- Offsider -->
      <!-- MainOffsider 기능을 MainTopMenu로 이동 -->
      <!-- <offsider @router-reload="routerReload()"></offsider> -->
    </section>
    <!-- Footer -->
    <footer :class="footerClass" @click="toggleFixTop(false)">
      <div class="ui--footer-in">
        <span>&copy; Samsung</span>
        <a href="javascript:" @click="showTermPopup('PERSONAL_USE', $event)"><strong>{{ $t('sdl.privacyPolicy.policyTitle') }}</strong></a>
        <!--<a href="javascript:" @click="showTermPopup('AGREE_USE', $event)">{{ $t('sdl.privacyPolicy.termsUseTitle') }}</a>-->
        <span class="confidential">Confidential</span>
        <span class="email">Contact us : <strong>{{ systemEmail }} (TEL: {{ systemTel }})</strong></span>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import TopMenu from './MainTopMenu';
import SideMenu from './MainSideMenu';
import Offsider from './MainOffsider';
import { SDLUtil } from '@/utils';
import TermPopup from '@/components/common/popup/TermPopup';

export default {
  name: 'Main',
  components: {
    TopMenu,
    SideMenu,
    Offsider,
  },
  data() {
    return {
      isFoldSideMenu: false,
      isHideSideMenu: false,
      isRouterAlive: true,
      fixTop: false,
      footerClass: 'ui--footer-container main_footer',
      systemEmail: process.env.SYSTEM_EMAIL,
      systemTel: process.env.SYSTEM_TEL,
    };
  },
  computed: {
    ...mapGetters({
      locale: 'getLocale',
      mainPath: 'getMainPath',
    }),
  },
  methods: {
    ...mapActions(['getMenus']),
    displaySideMenu(flag) {
      this.isHideSideMenu = flag;
    },
    routerReload() {
      this.isRouterAlive = false;
      setTimeout(() => {
        this.isRouterAlive = true;
      });
    },
    showTermPopup(termsTypeCode, event) {
      SDLUtil.showLoadingBar(true);
      const title = event.currentTarget.textContent;
      axios
        .get(`${SDLUtil.API_URL}/privacypolicy/terms/${termsTypeCode}/valid?langType=${this.locale}`)
        .then(({ data }) => {
          SDLUtil.show(
            TermPopup,
            {
              title,
              term: data,
            },
            {
              // width: '1000',
              // height: '850',
              // 가로사이즈 : big, large, medium, small, mini
              // 세로사이즈고정 : h_fix
              sizeClass: 'large',
            },
          );
          SDLUtil.showLoadingBar(false);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
        });
    },
    toggleFixTop(fix) {
      this.fixTop = fix;
    },
    toggleSideMenu() {
      this.isHideSideMenu = this.$route.path === this.mainPath;
    },
    toggleFooterClass() {
      if (this.$route.path === this.mainPath) {
        this.footerClass = 'ui--footer-container main_footer';
      }
      else {
        this.footerClass = 'ui--footer-container';
      }
    },
  },
  watch: {
    $route() {
      // this.isHideSideMenu = this.$route.meta.menuId === undefined;
      this.toggleSideMenu();
      this.toggleFooterClass();
    },
  },
  created() {
    // document.querySelector('body').classList.remove('ui--login-wrap', 'sdl-wrap');
    // Hide side menu area without menuId
    // this.isHideSideMenu = this.$route.meta.menuId === undefined;
  },
  beforeCreate() {
    const redirect = this.$router.history.current.query.redirect || '';
    if (redirect) {
      this.$router.replace(redirect);
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip();
    this.toggleSideMenu();
    this.toggleFooterClass();
  },
  updated() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip();
  },
  beforeRouteLeave(to, from, next) {
    if (from.name === 'mainIndexPage' && to.name === 'userSignup') console.log('Already Signed up.');
    else next();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainPage.vue